import { useEffect } from 'react';

const useDelayedEffect = (
    effect: () => void,
    delay: number,
    deps?: any[] // eslint-disable-line @typescript-eslint/no-explicit-any
) => {
    useEffect(() => {
        const timeout = window.setTimeout(effect, delay);

        return () => window.clearTimeout(timeout);
    }, deps);
};

export default useDelayedEffect;
